import { z } from 'zod'

export const MedicalRecordStatus = z.enum([
  'WAITING_FOR_REVIEW',
  'SENT',
  'EXPIRED',
  'COMPLETE'
])
export type MedicalRecordStatus = z.infer<typeof MedicalRecordStatus>
